import Vue from "vue";

Vue.component("wto-tag-input-objects", {
	props: ["label", "placeholder", "allowNew", "errorMessage", "dataSource", "dataObjects", "labelCssClass"],
	data() {
		return {
			filteredItems: []
		};
	},
	computed: {
		noData() {
			return window.labels.noData;
		},
		computedValue: {
			get() {
				const returnValue = [];
				if (this.dataObjects && this.dataObjects.length > 0) {
					this.dataObjects.forEach((item) => {
						returnValue.push(item);
					});
				}
				return returnValue;
			},
			set(selectedItem) {
				this.$emit("update:dataObjects", selectedItem);
			}
		}
	},
	mounted() {
		this.filteredItems = this.dataSource;
	},
	watch: {
		dataSource: function (val) {
			this.filteredItems = val;
		},
		computedValue: function (val) {
			this.filteredItems = this.dataSource.filter((option) => {
				return !val.includes(option);
			});
		}
	},
	methods: {
		getFilteredItem: function (text) {
			if (!text) text = '';
			this.filteredItems = this.dataSource.filter((option) => {
				return !this.computedValue.includes(option) && option.displayName.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0;
			});
		},
		handleBlur() {
			const tagInput = this.$refs.refTagInput;
			if (tagInput.newTag) {
				tagInput.newTag = "";
			}
		},
		beforeAdding: function(tag){
			this.getFilteredItem();
			return tag;	
		},
		addItem: function (text) {
			const tagInput = this.$refs.refTagInput;
			if (typeof text === "string") {
				const removeIndex = tagInput.tags.map(function (item) {
					return item;
				}).indexOf(text);
				tagInput.tags.splice(removeIndex, 1);

				const isExist = tagInput.tags.filter((option) => {
					return option.displayName.toString().toLowerCase() === text.toLowerCase();
				});

				if (!isExist || isExist.length === 0) {
					const dropdownItem = this.dataSource.filter((option) => {
						return option.displayName.toString().toLowerCase() === text.toLowerCase();
					});

					let newItem;
					if (dropdownItem && dropdownItem.length > 0) {
						newItem = dropdownItem[0];
					} else {
						newItem = {
							id: 0,
							displayName: text
						};
					}
					tagInput.tags.push(newItem);
					this.computedValue.push(newItem);
				}
			}
			tagInput.newTag = "";
			this.getFilteredItem();
		},
	},
	template: `
      <div class="column">
		  <b-field :class="labelCssClass" :label="label" :type="errorMessage ? 'is-danger' : ''" :message="errorMessage">
			<b-taginput v-model="computedValue"
						  :data="filteredItems"
						  :allow-duplicates="false"
						  :allow-new="allowNew"
						  :open-on-focus="true"
						  :placeholder="placeholder"
						  :before-adding="beforeAdding"
						  autocomplete
						  ref="refTagInput"
						  icon="label"
						  @typing="getFilteredItem"
						  @add="addItem">
				<template slot-scope="props">
				  {{ props.option.displayName }}
				</template>
				<template #empty>
				  {{ noData }}
				</template>
				<template #selected="props">
				  <b-tag v-for="(item, index) in props.tags" :key="index" rounded :tabstop="false" ellipsis closable @close="$refs.refTagInput.removeTag(index, $event)">
					{{ item.displayName }}
				  </b-tag>
				</template>
			  </b-taginput>
		  </b-field>
      </div>
	`
});